import React from 'react';
import {Form, Input, Select, Col, Row, InputNumber, message, DatePicker, Radio, Tree} from 'antd';
import Cookies from 'js-cookie';
import ModalDom from '../../../../components/Modal';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom } from '../../../../axios';
import {
    dicPayType,
    payCycleDate,
    payCycleType,
    paymentDate,
    wftSignType,
    wftSplitAccount
} from '../../../../axios/dictionaries';
import moment from 'moment';
import DetailTitle from "../../../../components/DetailTitle";
import {
    API_hsbPayChannel_add,
    API_hsbPayChannel_findBuildingHouseList,
    API_hsbPayChannel_getById, API_wftPayChannel_getById
} from "../../../../axios/config";
import {formatTime} from "../../../../utils";

const Option = Select.Option;

const { MonthPicker } = DatePicker;
const { TextArea } = Input;
const { TreeNode } = Tree;
class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            title: "编辑支付渠道",
            radioLessReliefTypeValue:false,
            merchantData: [],
            buildingData: [],
            checkedKeys: [], //选中的房源
            data: {
                houseLayout: [],
            },
        }

        // postFrom({ url: config.API_dictionary_findList, data: { groupName: '收款类别' } }).then(res => {
        //     this.setState({ receivablesType: res });
        // }).catch(err => {
        //     message.error(err.message || '获取收款类别失败');
        // });

        // postFrom({ url: config.API_project_findProjectPageList, data: { pageSize: 200 } }).then(res => {
        //     console.log(res.records);
        //     this.setState({ projectList: res.records });
        // }).catch(err => {
        //     message.error(err.message || '获取收款类别失败');
        // });
    }

    pullHouseMessage = (merchantId,jh) => { //拉取房源信息

        this.setState({ loading: true });
        postFrom({
            url: config.API_building_findBuildingList, data: {
                merchantId
            }
        }).then(res => {
            this.setState({ buildingData: res, loading: false }, () => {
                for (let i = 0; i < res.length; i++) {
                    this.handleGetFloor(res[i].id)
                }
            });
        }).catch(err => {
            message.error(err.message || '获取房源（小区/楼栋）列表失败');
            this.setState({ loading: false });
        });
    }

    handleGetFloor = (buildingId) => {
        postFrom({ url: config.API_hsbPayChannel_findBuildingHouseList, data: { buildingId } }).then(res => {
            let { data: { projectHouses }, checkedKeys, buildingData } = this.state;
            let existing = []; //存放当前项目关联的房源
            if (projectHouses instanceof Array) {
                existing = projectHouses.filter(item => +item.buildingId === buildingId);
            }
            let arr = [].concat(existing, res); //连接被关联的房源与未被关联的房源
            arr.sort((a, b) => a.floor - b.floor); //针对楼层排序
            let floor = [];
            arr.forEach(el => { //生成出分楼层房号的数组
                let value = floor.find(item => item.name === `楼层：${el.floor}`);
                if (value) {
                    value.children.push({ name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true })
                } else {
                    floor.push({
                        name: `楼层：${el.floor}`,
                        id: `${el.houseId}·${el.floor}`,
                        children: [
                            { name: `房号：${el.roomNo}`, id: `houseId${el.houseId}`, isChild: true }
                        ]
                    })
                }
            });
            floor.forEach((el => { //针对房号排序
                el.children.sort((a, b) => a.name.slice(3) - b.name.slice(3));
            }));
            let nowBuilding = buildingData.find(item => item.id === buildingId);
            nowBuilding ? nowBuilding.children = floor : null;
            for (let i = 0; i < existing.length; i++) { //加入已被关联房源的选中
                if (checkedKeys.indexOf(`houseId${existing[i].houseId}`) === -1) {
                    checkedKeys.push(`houseId${existing[i].houseId}`);
                }
            }
            this.setState({ buildingData, checkedKeys });
        }).catch(err => {
            message.error(err.message || '获取未关联房源列表失败');
        });
    }

    handleLessReliefTypeChange = (e) => { // 最低减免类型
        const radioLessReliefTypeValue = e.target.value
        this.setState({
            radioLessReliefTypeValue
        })
    }

    render() {
        let { visible, form: { getFieldDecorator, setFieldsValue } } = this.props;
        let {
            loading,
            title,
            data,
            merchantData,
            buildingData,
            checkedKeys,
        } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
        >
            <div className="custom">
                <Form
                    labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}
                >
                    {getFieldDecorator('id', {
                        initialValue: data.id
                    })(
                        <Input type={'hidden'} />
                    )}
                    <Row>
                        <Col span={24}>
                            <CustomRow>
                                <CustomCol label="商户名称">
                                    {getFieldDecorator('merchantId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.merchantId
                                    })(
                                        <Select
                                            showSearch
                                            // style={{ width: 275 }}
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={(value) => {
                                                this.pullHouseMessage(value,null);
                                            }}
                                        >
                                            {merchantData.map((item, index) => <Option value={item.value} key={item.value}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                                <CustomCol label="支付渠道名称">
                                    {getFieldDecorator('projectName', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.projectName
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol  label="威富通商户号">
                                    {getFieldDecorator('mchId', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.mchId
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol  label="是否分账">
                                    {getFieldDecorator('splitAccount', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.splitAccount
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {wftSplitAccount.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>

                            <CustomRow divider>
                                <CustomCol  label="支付签名方式">
                                    {getFieldDecorator('signType', {
                                        rules: [{
                                            required: true, message: '请输入',
                                        }],
                                        initialValue: data.signType
                                    })(
                                        <Select
                                            showSearch
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                            onChange={(e) => this.handleFormChange({signType: e})}
                                        >
                                            {wftSignType.map((item, index) => <Option value={item.value} key={index}>{item.title}</Option>)}
                                        </Select>
                                    )}
                                </CustomCol>
                            </CustomRow>
                            {
                                data.signType==='MD5'?
                                <CustomRow divider>
                                    <CustomCol label="MD5_Key" required={false} labelStyle={{height: '60px'}}
                                               colStyle={{width: '500px', height: '60px'}}>
                                        {getFieldDecorator('md5Key', {
                                            initialValue: data.md5Key
                                        })(
                                            <TextArea style={{height: '100%', padding: '11px', lineHeight: '20px'}}/>
                                        )}
                                    </CustomCol>
                                </CustomRow>:null
                            }
                            {
                                data.signType === 'RSA_1_256' ?
                                    <CustomRow divider>
                                        <CustomCol label="RSA_私钥" required={false} labelStyle={{height: '60px'}}
                                                   colStyle={{width: '500px', height: '60px'}}>
                                            {getFieldDecorator('mchPrivateKey', {
                                                initialValue: data.mchPrivateKey
                                            })(
                                                <TextArea
                                                    style={{height: '100%', padding: '11px', lineHeight: '20px'}}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>:null
                            }
                            {
                                data.signType === 'RSA_1_256' ?
                                    <CustomRow divider>
                                        <CustomCol label="RSA_公钥" required={false} labelStyle={{height: '60px'}}
                                                   colStyle={{width: '500px', height: '60px'}}>
                                            {getFieldDecorator('platPublicKey', {
                                                initialValue: data.platPublicKey
                                            })(
                                                <TextArea
                                                    style={{height: '100%', padding: '11px', lineHeight: '20px'}}/>
                                            )}
                                        </CustomCol>
                                    </CustomRow>:null
                            }

                            <DetailTitle title="支付渠道关联房源" />
                            {
                                buildingData.length
                                    ? <Tree
                                        multiple
                                        checkable
                                        onCheck={
                                            (checkedKeys) => {
                                                this.setState({ checkedKeys });
                                            }
                                        }
                                        checkedKeys={checkedKeys}
                                    >
                                        {this.renderTreeNodes(buildingData)}
                                    </Tree>
                                    : <div style={{ textAlign: 'center' }}>暂无数据</div>
                            }
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    handleFormChange = (data) => {
        console.log("选择的值：" + data.signType);
        this.state.data.signType=data.signType;
    }

    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode selectable={false} title={item.name} key={item.id} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.name} key={item.id} dataRef={item} isLeaf={item.isChild} />;
        })
    }

    handleCancel = () => { //关闭页面
        this.props.handleCancel();

        this.setState({ data: {}, loading: false, title: "新增支付渠道",buildingData: [], checkedKeys: [], });
    }

    initPack = () => {
        this.forceUpdate();
        postFrom({
            url: config.API_merchant_findAll,
            data: {}
        }).then(res => {
            let merchantData = res.map(item => ({ title: item.shortName, value: item.id, name: item.name,isJr:item.isJr,zjbDataSync:item.zjbDataSync }));
            this.setState({ merchantData });
        }).catch(err => {
            message.error(err.message || '获取商户列表失败');
            this.setState({ loading: false });
        });

    }

    loadPack = ({ id }) => {
        this.setState({ loading: true, title: "编辑支付渠道" });
        postFrom({ url: config.API_wftPayChannel_getById+"?id="+id, data: { } }).then(res => {
            this.setState({ data:{ ...res, id }, loading: false });
            this.pullHouseMessage(res.merchantId,null);
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        });


    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                values.merchantName = this.state.merchantData.find(item => item.value === values.merchantId); //处理商户
                values.merchantName = values.merchantName ? values.merchantName.name : '';
                let projectHouses = this.state.data.projectHouses;
                let isHouse = projectHouses instanceof Array; //确定有房源数组
                let houseId = this.state.checkedKeys.filter(item => item.startsWith('houseId')); //删除选中的房源数据
                houseId = houseId.map(item => {
                    item = +item.slice(7);
                    if (isHouse) {
                        let house = projectHouses.find(items => items.houseId === item); //当前房源是否被选中
                        if (house) {
                            return { id: house.id, houseId: item }
                        }
                        return { houseId: item }
                    } else {
                        return { houseId: item }
                    }
                });
                values.houseList = houseId;


                this.setState({ loading: true });

                if (values.id) {
                    post({ url: config.API_wftPayChannel_update, data: values }).then(res => {
                        message.success('编辑成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '编辑失败');
                        this.setState({ loading: false });
                    })
                } else {
                    post({ url: config.API_wftPayChannel_add, data: values }).then(res => {
                        message.success('新增成功');
                        this.props.handleGetList();
                        this.handleCancel();
                    }).catch(err => {
                        message.error(err.message || '新增失败');
                        this.setState({ loading: false });
                    })
                }
            }
        })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/WftPayChannel/components/ListAdd/index.js